export default "__VITE_ASSET__D8h2sezJ__"